import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=11d2ed9a&scoped=true"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"
import style0 from "./Feed.vue?vue&type=style&index=0&id=11d2ed9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d2ed9a",
  null
  
)

export default component.exports